import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-family: "Jeju Gothic", "Spoqa Han Sans", "Spoqa Han Sans JP", "Sans-serif"; //Raleway
  }

  h1, h2, h3 {
    margin: 0;
    padding: 0;
    color: #2a2a2a;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 400;
  }


  h1 {
    // @media ${({ theme }) => theme.device.mobile} {
    @media (max-width: 767px) {
      font-size: 26px;
      line-height: 1.31;
    }
    //@media ${({ theme }) => theme.device.notMobile} {
    @media (min-width: 768px) {
      font-size: 50px;
      line-height: 1.36;
    }
  }

  h2 {
    // @media ${({ theme }) => theme.device.mobile} {
    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 1.5;
    }
    //@media ${({ theme }) => theme.device.notMobile} {
    @media (min-width: 768px) {
      font-size: 40px;
      line-height: 1.25;
    }
  }

  h3 {
    line-height: 1.08;
    // @media ${({ theme }) => theme.device.mobile} {
    @media (max-width: 767px) {
      font-size: 15px;
    }
    //@media ${({ theme }) => theme.device.notMobile} {
    @media (min-width: 768px) {
      font-size: 26px;
      font-weight: 600;
    }
  }

  h4, p, ul, li, label, button, input, span {
    font-family: "Spoqa Han Sans", "Spoqa Han Sans JP", "Sans-serif";
  }
  
  ul {
    padding-left: 0;
    list-style: none;
  }

  label {
    font-size: 16px;
  }

  p {
    margin-top: 14px;
    color: rgba(0, 0, 0, 0.85);
    // @media ${({ theme }) => theme.device.mobile} {
    @media (max-width: 767px) {
      font-size: 15px;
      line-height: 1.47;
    }
    //@media ${({ theme }) => theme.device.notMobile} {
    @media (min-width: 768px) {
      font-size: 20px;
      line-height: 1.6;
    }

    a.inline {
      width: auto;
      height: auto;
      background-color: #ffffff;
      -webkit-border-radius: 0;
      -moz-border-radius: 0;
      -o-border-radius: 0;
      border-radius: 0;
      border: 0;
      padding: 0;
      margin: 0;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
      text-decoration: underline;
      white-space: wrap;
    }
  }

  label {
    display: block;
    color: #6d7278;

    // @media ${({ theme }) => theme.device.mobile} {
    @media (max-width: 767px) {
      font-size: 12px;
    }
    // @media ${({ theme }) => theme.device.notMobile} {
    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 1.38;
    }
  }

  input {
    width: 100%;
    padding: 0 10px;
    margin-top: 10px;

    border-radius: 2px;
    border: none;
    // background-color: ${({ theme }) => theme.color.section};
    display: block;

    // @media ${({ theme }) => theme.device.mobile} {
    @media (max-width: 767px) {
      font-size: 16px;
      height: 40px;
    }
    // @media ${({ theme }) => theme.device.notMobile} {
    @media (min-width: 768px) {
      height: 54px;
    }

    ::placeholder {
      height: 24px;
      font-size: 20px;
      color: #adadad;
      //@media ${({ theme }) => theme.device.mobile} {
      @media (max-width: 767px) {
        font-size: 16px;
      }
    }
  }
  
  textarea {
    // @media ${({ theme }) => theme.device.mobile} {
    @media (max-width: 767px) { 
      font-size: 16px;
    }
  }

  button {
    @media (max-width: 767px) {
      //font-size: 16px;
      //height: 52px;
    }
    @media (min-width: 768px) {
      //font-size: 20px;
      //height: 55px;
    }
    line-height: 1.5715;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: manipulation;
    height: 32px;
    padding: 4px 15px;
    font-size: 14px;
    border-radius: 2px;
    color: rgba(0, 0, 0, 0.85);
    background: #fff;
    border: 1px solid #d9d9d9;
  }
  button.primary {
    color: #fff;
    background: #1890ff;
    border-color: #1890ff;
    text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
  }

    .container {
    // @media ${({ theme }) => theme.device.mobile} {
    @media (max-width: 767px) {
      padding-left: 20px;
      padding-right: 20px;

      h3, p {
        line-height: 1.4;
      }
    }

    // @media ${({ theme }) => theme.device.notMobile} {
    @media (min-width: 768px) {
      padding-left: 11.458%;
      padding-right: 11.458%;
    }
  }

  .ant-modal-confirm-btns {
    float: none !important;
    text-align: center;
  }
`;

export default GlobalStyle;
